export default {
  id: "totalTransactions",
  name: "",
  description: "",
  report: {
    name: "Total Transactions",
    chartType: "NUMBER",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: [],
      measures: ["Sale.count"],
      filters: [],
      compare: false,
      limit: "1",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
